/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jun 09 2025
 **/

import { useQueryClient } from "@tanstack/react-query";

import { useChat } from "@/frameworks/core/API";

export default function useActivityBookmarkActions() {
	const queryClient = useQueryClient();
	const chatAPI = useChat();

	const fetch = async (pageParam: string | undefined) => {
		const { data } = await chatAPI.activity.getActivities.execute({ type: "BOOKMARK", cursorId: pageParam });
		return data;
	};

	const refetch = () => {
		queryClient.refetchQueries({ queryKey: ["activity:bookmark"] });
	};

	return {
		fetch,
		refetch
	};
}
